<template>
  <div>
    <div id="mask" v-if="popupState==='SHOW'||popupState==='ERROR'"></div>
    <transition name="err">
      <div class="popup" v-if="popupState==='SHOW'">
        <div class="row">
          <div class="col-12">
            <h1>{{ $t("generate.note1") }}</h1>
          </div>
        </div>
        <div class="row">
          <div class="col-4">
            <img id="box" src="../assets/mme-schachtel.png" />
          </div>
          <div class="col-8">
            <p v-html="$t('generate.p1')"></p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 right">
            <button class="btn btn-primary" @click="next"></button>
          </div>
        </div>
      </div>
    </transition>

    <div class="row vertical-center">
      <div class="col-12 center">
        <div class="circle-container" v-if="popupState===''">
          <svg class="loader" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 340 340">
            <circle cx="170" cy="170" r="160" stroke="#006266" />
            <circle cx="170" cy="170" r="135" stroke="#404041" />
            <circle cx="170" cy="170" r="110" stroke="#006266" />
            <circle cx="170" cy="170" r="85" stroke="#404041" />
          </svg>
        </div>
        <h1 v-if="popupState===''">{{ $t("generate.caption") }}</h1>
      </div>
    </div>
  </div>
</template>
<script>
import participant from "../modules/Participant"
import adjectives from "../modules/Adjectives"

export default {
  name: "Generate",
  data() {
    return {
      popupState: "",
    }
  },
  methods: {
    next() {
      this.$router.push("/result")
    },
  },
  mounted() {
    window.scrollTo(0, 1)
    setTimeout(() => {
      this.popupState = "SHOW"
    }, 3000)
  },
  created() {
    if (participant.tan === null) {
      this.$router.push("/tan")
    } else {
      this.$http
        .get(
          "https://service.psyfiers.ch/java/service/adjectives/create?s=" +
            participant.s +
            "&n=" +
            participant.n +
            "&f=" +
            participant.f +
            "&t=" +
            participant.t +
            "&f=" +
            participant.f +
            "&lang=" +
            this.$i18n.locale +
            "&full=false"
        )
        .then((response) => {
          adjectives.links = []
          for (let k in response.data) {
            if (response.data.hasOwnProperty(k)) {
              adjectives.links.push({
                name: k,
                link:
                  "https://service.psyfiers.ch/java/service/adjectives/img?a=" +
                  k +
                  "&lang=" +
                  this.$i18n.locale,
              })
            }
          }
        })
    }
  },
}
</script>

<style scoped>
h1 {
  margin-top: 100px;
}
.container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
}

.loader {
  max-width: 15rem;
  width: 100%;
  height: auto;
  stroke-linecap: round;
}
circle {
  fill: none;
  stroke-width: 3.5;
  animation-name: preloader;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  transform-origin: 170px 170px;
  will-change: transform;
}
circle:nth-of-type(1) {
  stroke-dasharray: 550px;
}
circle:nth-of-type(2) {
  stroke-dasharray: 500px;
}
circle:nth-of-type(3) {
  stroke-dasharray: 450px;
}
circle:nth-of-type(4) {
  stroke-dasharray: 300px;
}
circle:nth-of-type(1) {
  animation-delay: -0.15s;
}
circle:nth-of-type(2) {
  animation-delay: -0.3s;
}
circle:nth-of-type(3) {
  animation-delay: -0.45s;
}
circle:nth-of-type(4) {
  animation-delay: -0.6s;
}
@keyframes preloader {
  50% {
    transform: rotate(360deg);
  }
}

#box {
  /*position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);*/
  width: 100%;
  height: auto;
  padding-right: 5px;
}

#mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: black;
  opacity: 0.5;
  z-index: 1;
}
.popup {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #e5efef;
  padding: 30px;
  padding-top: 0px;
  border-radius: 30px;
  border: 1px solid #ccc;
  max-width: 800px;
  z-index: 2;
  font-size: 110%;
}

.popup h1 {
  font-family: MyriadSB, Arial, Helvetica, sans-serif;
  margin-top: 25px;
  margin-bottom: 25px;
}

.closebtn {
  position: absolute;
  top: -16px;
  right: 0px;
  border-radius: 50%;
  height: 35px;
  width: 35px;
  border: 1px solid gray;
  background-color: white;
  color: gray;
  font-weight: bold;
  outline: none;
}

.btn {
  border-radius: 50% !important;
  height: 100px !important;
  width: 100px !important;
  font-size: 0px !important;
}

.btn-primary {
  border-color: white !important;
  background-color: white !important;
  max-width: 100px;
  max-height: 100px;
  background-image: url("../assets/web_button.png");
  background-repeat: no-repeat;
  background-size: cover;
}

@media screen and (max-width: 770px) {
  .popup {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    background-color: #e5efef;
    padding: 10px;
    border-radius: 30px;
    border: 1px solid #ccc;
    width: 95%;
    max-width: 800px;
    z-index: 2;
  }
}
@media screen and (max-width: 770px) and (orientation: landscape) {
  #box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 75%;
    height: auto;
  }
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}
@media screen and (max-width: 770px) and (orientation: portrait) {
  #box {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 75%;
    height: auto;
  }
  .btn-primary {
    border-color: white !important;
    background-color: white !important;
    max-width: 65px;
    max-height: 65px;
    background-image: url("../assets/web_button.png");
    background-repeat: no-repeat;
    background-size: cover;
  }

  .btn {
    height: 65px !important;
    width: 65px !important;
    font-size: 0px !important;
  }
}

@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .popup {
    min-width: 600px;
  }
}
</style>
